import { ProjectSchema } from "@/components/_Shared/Form/Schemas/ProjectSchema";
import { baseFormSchema } from "./baseFormSchema";


export const taskFormSchema = baseFormSchema.merge(ProjectSchema);
